import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Heading,
  VStack,
  FormControl,
  Input,
  Link,
  Button,
  HStack,
  Center,
  Pressable,
  Icon,
  NativeBaseProvider,
  Image,
  useToast,
} from "native-base";
import { GlobalStyles } from "./../constants/styles";
import { GlobalConstants } from "./../constants/constants";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { MaterialIcons } from "@expo/vector-icons";
import SetUser from "../redux/user/SetUser";
import Toast from "../components/Toast";

const ForgetPassword = () => {
  const navigation = useNavigation();
  const toast = useToast();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(true);
  const [resetPassword, setResetPassword] = useState(false);
  const [updatePassword, setUpdatedPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState("");

  const handleSendOtp = async () => {
    if (!email) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Please enter your email!"
          />
        ),
        placement: "top",
      });
      return;
    }
  
    setIsLoading(true);
  
    try {
      const response = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}users/send-otp`, {
        email: email.trim(),
      });
  
      if (response.data.status) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="OTP sent successfully!"
            />
          ),
          placement: "top",
        });
        const masked = maskEmail(email);
        setMaskedEmail(masked)
        setForgetPassword(false);
        setResetPassword(true);

      } else {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message={response.data.message || "Failed to send OTP"}
            />
          ),
          placement: "top",
        });
      }
    } catch (err) {
      console.error(err);
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Something went wrong!"
          />
        ),
        placement: "top",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleResetPassword = async () => {
    if (!code.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={"Please enter the OTP code"}
          />
        ),
        placement: "top",
      });
      return;
    }
  
    if (newPassword !== confirmNewPassword) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={"Passwords do not match"}
          />
        ),
        placement: "top",
      });
      return;
    }
  
    try {
      setIsLoading(true);
      const response = await axios.post(`${GlobalConstants.townTicksBaseUrl}users/forgot-password`, {
        email: email.trim(),
        otp: code.trim(),
        new_password: newPassword,
      });
  
      if (response.data?.status === true) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message={"Password reset successfully"}
            />
          ),
          placement: "top",
        });
        setResetPassword(false);
        setUpdatedPassword(true);

      } else {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message={response.data.message || "Failed to reset password"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={"Something went wrong. Please try again."}
          />
        ),
        placement: "top",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const maskEmail = (email) => {
    const [localPart, domain] = email.split("@");
  
    const maskedLocal =
      localPart.length <= 2
        ? localPart[0] + "*".repeat(localPart.length - 1)
        : localPart.slice(0, 2) + "*".repeat(localPart.length - 2);
  
    const maskedDomain = domain ? "*".repeat(domain.length) : "";
  
    return `${maskedLocal}@${maskedDomain}`;
  };


  useEffect(() => {
    
  }, []);

  return (
    <Center w="100%">
      <Box safeArea p="2" py="8" w={[320, 350, 600]}>
        {/* <Heading
          size="lg"
          color={GlobalStyles.colors.blue}
          fontFamily={GlobalStyles.text.fontFamily}
          fontSize="2xl"
          fontWeight="bold"
        >
          Sign In
        </Heading>
        <Heading
          mt="1"
          _dark={{
            color: "warmGray.200",
          }}
          color="coolGray.600"
          fontWeight="medium"
          size="xs"
        >
          Sign in to continue!
        </Heading> */}
       {forgetPassword && (
        <VStack space={3} mt="5">
            <Heading
            size="lg"
            color={GlobalStyles.colors.blue}
            fontFamily={GlobalStyles.text.fontFamily}
            fontSize="2xl"
            fontWeight="bold"
            alignSelf="center"
            >
            Forget Password
            </Heading>
            <Image
                    source={require("../../assets/lock.png")}
                    alt="Alternate Text"
                    w="160px"
                    h="160px"
                    alignSelf="center"
                    />
          <FormControl>
            <FormControl.Label>Email</FormControl.Label>
            <Input
              type="email"
              onChange={(x) => {
                setEmail(x.target.value);
              }}
            />
            <Link
              _text={{
                fontSize: "xs",
                fontWeight: "500",
                color: "indigo.500",
              }}
              alignSelf="flex-end"
              mt="4"
              onPress={() => navigation.navigate("SignIn")}
            >
             Back to Log In
            </Link>
          </FormControl>
          <Button
            isLoading={isLoading}
            mt="2"
            size="sm"
            variant={"solid"}
            px="3"
            bg={GlobalStyles.colors.blue}
            borderColor={GlobalStyles.colors.mustard}
            borderWidth={2}
            onPress={handleSendOtp}
          >
            Send Code
          </Button>
        </VStack>
       )}
       {resetPassword && (
         <VStack space={3} mt="5">
                <HStack alignItems="center" justifyContent="space-between">
                <Pressable onPress={() => {
                        setResetPassword(false);
                        setForgetPassword(true);
                        }}>
                    <Icon
                    as={<MaterialIcons name="arrow-back" />}
                    size="6"
                    color={GlobalStyles.colors.blue}
                    />
                </Pressable>
                <Heading
                    size="lg"
                    color={GlobalStyles.colors.blue}
                    fontFamily={GlobalStyles.text.fontFamily}
                    fontSize="2xl"
                    fontWeight="bold"
                    textAlign="center"
                    flex={1}
                    
                >
                    Reset Password
                </Heading>
                </HStack>
                <Image
                        source={require("../../assets/key.png")}
                        alt="Alternate Text"
                        w="160px"
                        h="160px"
                        alignSelf="center"
                        />
                  <Heading
                    mt="1"
                    _dark={{
                        color: "warmGray.200",
                    }}
                    color="coolGray.600"
                    fontWeight="medium"
                    fontSize="10px"
                    >
                    We have sent a password reset code by email to {maskedEmail}   Enter it below to reset your password.
                 </Heading>      
            <FormControl>
                <FormControl.Label>Code</FormControl.Label>
                <Input
                type="text"
                onChange={(x) => {
                    setCode(x.target.value);
                }}
                /><HStack alignSelf="flex-end">
                    <Text
                        fontSize="xs"
                        fontWeight= "500"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color="#737373"
                        mt="4"
                        >
                        Didn't receive code;
                        </Text>
                    <Link
                        _text={{
                        fontSize: "xs",
                        fontWeight: "500",
                        color: "indigo.500",
                        }}
                        alignSelf="flex-end"
                        mt="4"
                        onPress={handleSendOtp}
            >
                Resend
            </Link></HStack>
                
            </FormControl>
            <FormControl>
                <FormControl.Label>Enter New Password</FormControl.Label>
                <Input
                    type={showPassword ? "text" : "password"}
                    placeholder="Mix of letters and simbols"
                    value={newPassword}
                    onChange={(x) => setNewPassword(x.target.value)}
                    InputRightElement={
                    <Pressable onPress={() => setShowPassword(!showPassword)}>
                        <Icon
                        as={<MaterialIcons name={showPassword ? "visibility" : "visibility-off"} />}
                        size={5}
                        mr="2"
                        color="muted.400"
                        />
                    </Pressable>
                    }
                />
                </FormControl>
            <FormControl>
                <FormControl.Label>Confirm Password</FormControl.Label>
                <Input
                
                type={showNewPassword ? "text" : "password"}
                value={confirmNewPassword}
                onChange={(x) => {
                    setConfirmNewPassword(x.target.value);
                }}
                InputRightElement={
                    <Pressable onPress={() => setShowNewPassword(!showNewPassword)}>
                        <Icon
                        as={<MaterialIcons name={showNewPassword ? "visibility" : "visibility-off"} />}
                        size={5}
                        mr="2"
                        color="muted.400"
                        />
                    </Pressable>
                    }
                />
            </FormControl>
            <Button
                isLoading={isLoading}
                mt="2"
                size="sm"
                variant={"solid"}
                px="3"
                bg={GlobalStyles.colors.blue}
                borderColor={GlobalStyles.colors.mustard}
                borderWidth={2}
                onPress={handleResetPassword}
            >
                Done
            </Button>
            </VStack>
       )}
        {updatePassword && (
        <VStack space={3} mt="5" >
        <Heading
          size="lg"
          color={GlobalStyles.colors.blue}
          fontFamily={GlobalStyles.text.fontFamily}
          fontSize="2xl"
          fontWeight="bold"
          alignSelf="center"
        >
          Password Updated
        </Heading>
        <Image
                  source={require("../../assets/update.png")}
                  alt="Alternate Text"
                  w="160px"
                  h="160px"
                  alignSelf="center"
                />
        <Heading
          mt="1"
          _dark={{
            color: "warmGray.200",
          }}
          color="coolGray.600"
          fontWeight="medium"
          size="xs"
          alignSelf="center"
        >
          Your password has been successfully updated!
        </Heading> 
         
          <Button
            // isLoading={isLoading}
            mt="2"
            size="sm"
            variant={"solid"}
            px="3"
            bg={GlobalStyles.colors.blue}
            borderColor={GlobalStyles.colors.mustard}
            borderWidth={2}
            onPress={() => navigation.navigate("SignIn")}
          >
            Log In
          </Button>
        </VStack>
        )}
      </Box>
    </Center>
  );
};

export default ForgetPassword;
